import { render, staticRenderFns } from "./Layout.vue?vue&type=template&id=31a768e4"
import script from "./Layout.vue?vue&type=script&lang=js"
export * from "./Layout.vue?vue&type=script&lang=js"
import style0 from "./Layout.vue?vue&type=style&index=0&id=31a768e4&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31a768e4')) {
      api.createRecord('31a768e4', component.options)
    } else {
      api.reload('31a768e4', component.options)
    }
    module.hot.accept("./Layout.vue?vue&type=template&id=31a768e4", function () {
      api.rerender('31a768e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Layout.vue"
export default component.exports